import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateSignatureComponent } from "../../templates/template-signature/template-signature.component";

@Component({
  selector: "app-prefix-si2",
  imports: [TemplateSignatureComponent],
  templateUrl: "./prefix-si2.component.html",
  styleUrl: "./prefix-si2.component.less",
})
export class PrefixSi2Component extends PrefixComponent<string> {
  public readonly: boolean;

  public constructor() {
    super();
    this.characters = ALLOWED_CHARACTERS["si2"];
    this.readonly = true;
  }
}
